import { render, staticRenderFns } from "./pi-no-list-data.vue?vue&type=template&id=2aa8a488&"
import script from "./pi-no-list-data.vue?vue&type=script&lang=js&"
export * from "./pi-no-list-data.vue?vue&type=script&lang=js&"
import style0 from "./pi-no-list-data.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports